<template>
  <slot name="activator" :open="open"></slot>
  <Teleport to="#slideout-target">
    <transition name="fade">
      <sel-backdrop :class="bemClass('overlay')"
                    :modifier="modifier"
                    :is-active="isActive"
                    @click="close"
      />
    </transition>
    <transition :name="transitionName">
      <div :class="[bemClass()]" v-bind="$attrs" v-show="isActive">
        <div :class="bemClass('inner')">
          <div :class="bemClass('content')" ref="el">
            <sel-button :class="bemClass('close')" @click.prevent="close">
              <slot name="close-icon">
                <sel-icon icon-name="icon-close"></sel-icon>
              </slot>
            </sel-button>
            <slot :open="open" :close="close" :set-disable-scroll-ref="setDisableScrollRef"></slot>
          </div>
        </div>
      </div>
    </transition>
  </Teleport>
</template>

<script>
import { ref, toRefs } from 'vue'
import activator from '../../compositions/activator'
import useBem from '../../compositions/bem'
import useBodyScrollLock from '../../compositions/body-scroll-lock'
import { useRefs } from '../../compositions/template-ref'

export default {
  name: 'SelSlideout',
  inheritAttrs: false,
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    activatorSelector: {
      type: String
    },
    transitionName: {
      type: String,
      default: 'slide-left'
    },
    modifier: {
      type: String,
      default: ''
    }
  },
  setup (props, { emit }) {
    const { modifier, isActive } = toRefs(props)
    const { bemClass } = useBem('sel-slideout', modifier)
    const el = ref(null)
    const [disableScrollEls, setDisableScrollRef] = useRefs()

    useBodyScrollLock(el, isActive)
    useBodyScrollLock(disableScrollEls, isActive)

    return {
      el,
      bemClass,
      setDisableScrollRef,
      ...activator(props, { emit })
    }
  }
}
</script>

<style scoped>
  .sel-slideout,
  .sel-slideout__overlay {
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }

  .sel-slideout {
    max-width: 320px;
    background-color: white;
    border: 1px solid #000;
    z-index: 2;
  }

  .sel-slideout__overlay {
    background-color: rgba(255, 255, 255, 0.5);
    z-index: 1;
  }

  .sel-slideout__inner {
    height: 100%;
    padding: 30px;
  }

  .sel-slideout__close {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 2;
  }
  .sel-slideout__content {
    height: 100%;
    overflow-y: auto;
  }
</style>
